(function () {
  'use strict';

  const API_BASE = '/apps/tecdoc';
  const STORAGE_KEY = 'vehicle_fitment_vehicle';

  const $ = (root, selector) => root ? root.querySelector(selector) : null;
  const $$ = (root, selector) => root ? Array.from(root.querySelectorAll(selector)) : [];

  function esc(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function api(path) {
    return fetch(API_BASE + path, { headers: { Accept: 'application/json' } })
      .then(async (response) => {
        const json = await response.json().catch(() => null);
        if (!response.ok || !json || json.success === false) {
          throw new Error((json && json.error) || `Requête impossible (${response.status})`);
        }
        return json.data || [];
      });
  }

  function fieldValue(item, names) {
    for (const name of names) {
      if (item && item[name] != null) return item[name];
    }
    return '';
  }

  function translateVehicleText(value) {
    return window.GarageVehicleLabels && window.GarageVehicleLabels.translateText
      ? window.GarageVehicleLabels.translateText(value)
      : String(value || '');
  }

  function vehicleName(vehicle) {
    return [
      fieldValue(vehicle, ['makeName', 'MakeName']),
      translateVehicleText(fieldValue(vehicle, ['modelName', 'ModelName'])),
      translateVehicleText(fieldValue(vehicle, ['typeName', 'TypeName']))
    ].filter(Boolean).join(' ');
  }

  function vehicleMeta(vehicle) {
    return [
      fieldValue(vehicle, ['engineCode', 'EngineCode']),
      fieldValue(vehicle, ['powerHp', 'PuissanceHp']),
      [fieldValue(vehicle, ['yearFrom', 'AnnéeFrom']), fieldValue(vehicle, ['yearTo', 'AnnéeTo'])].filter(Boolean).join('-')
    ].filter(Boolean).join(' | ');
  }

  function vehicleId(vehicle) {
    return fieldValue(vehicle, ['vehicleId', 'VehicleId', 'id', 'Id']);
  }

  function vehicleImage(vehicle) {
    return fieldValue(vehicle, ['imageUrl', 'ImageUrl']);
  }

  function option(select, value, label) {
    const node = document.createElement('option');
    node.value = value == null ? '' : String(value);
    node.textContent = label || '';
    select.appendChild(node);
    return node;
  }

  function setStatus(root, text) {
    const status = $(root, '[data-vf-status]');
    if (status) status.textContent = text || '';
  }

  function setLoading(select, label) {
    select.innerHTML = '';
    option(select, '', label || 'Chargement...');
    select.disabled = true;
  }

  function resetSelect(select, label) {
    select.innerHTML = '';
    option(select, '', label);
    select.disabled = true;
  }

  function hasOption(select, value) {
    const target = String(value == null ? '' : value);
    return Array.from(select.options).some((item) => item.value === target);
  }

  function saveVehicle(root, vehicle) {
    const config = root.dataset;
    const rawVehicleId = vehicleId(vehicle);
    const normalizedVehicleId = rawVehicleId === '' || rawVehicleId == null ? '' : Number(rawVehicleId);
    const payload = {
      ...vehicle,
      id: Number.isFinite(normalizedVehicleId) ? normalizedVehicleId : rawVehicleId,
      storeId: config.storeId || 'injecteurgarage',
      tecDocProfile: config.tecDocProfile || 'fr',
      family: config.family || 'injecteurs',
      savedAt: Date.now()
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    document.dispatchEvent(new CustomEvent('vehiclefitment:selected', { detail: payload }));
    return payload;
  }

  function clearVehicle() {
    localStorage.removeItem(STORAGE_KEY);
    document.dispatchEvent(new CustomEvent('vehiclefitment:cleared'));
  }

  function shouldStartFreshSelection() {
    try {
      return new URLSearchParams(window.location.search).get('changeVehicle') === '1';
    } catch (_) {
      return false;
    }
  }

  function removeFreshSelectionFlag() {
    try {
      const url = new URL(window.location.href);
      if (!url.searchParams.has('changeVehicle')) return;
      url.searchParams.delete('changeVehicle');
      window.history.replaceState({}, document.title, `${url.pathname}${url.search}${url.hash}`);
    } catch (_) { }
  }

  function renderSelected(root, vehicle) {
    const selected = $(root, '[data-vf-selected]');
    if (!selected) return;

    if (!vehicle) {
      selected.classList.remove('is-visible');
      selected.innerHTML = '';
      return;
    }

    const label = vehicleName(vehicle);
    const meta = vehicleMeta(vehicle);
    const image = vehicleImage(vehicle);
    const make = fieldValue(vehicle, ['makeName', 'MakeName']);

    selected.classList.add('is-visible');
    selected.innerHTML = `
      <span class="vehicle-fitment__selected-media">
        ${image ? `<img src="${esc(image)}" alt="${esc(label)}" loading="lazy">` : `<span aria-hidden="true">${esc(String(make || label).slice(0, 1))}</span>`}
      </span>
      <span class="vehicle-fitment__selected-copy">
        <strong>${esc(label)}</strong>
        ${meta ? `<small>${esc(meta)}</small>` : ''}
      </span>`;
  }

  function selectedVehicleFromSelect(select) {
    const option = select && select.selectedOptions && select.selectedOptions[0];
    if (!option || !option.dataset.vehicle) return null;
    try {
      return JSON.parse(option.dataset.vehicle);
    } catch (_) {
      return null;
    }
  }

  function buildResultsUrl(root, saved) {
    const target = root.dataset.resultsUrl || '/pages/compatibilite-vehicule';
    const url = new URL(target, window.location.origin);
    url.searchParams.set('vehicleId', String(saved.id || saved.vehicleId || ''));
    url.searchParams.set('storeId', saved.storeId || root.dataset.storeId || 'injecteurgarage');
    url.searchParams.set('tecDocProfile', saved.tecDocProfile || root.dataset.tecDocProfile || 'fr');
    url.searchParams.set('family', saved.family || root.dataset.family || 'injecteurs');
    return `${url.pathname}${url.search}`;
  }

  function initMedia(root) {
    const media = $(root, '[data-vf-media]');
    if (!media || media.dataset.mediaReady === 'true') return;
    media.dataset.mediaReady = 'true';

    const slides = $$(media, '[data-vf-slide]');
    const dots = $$(media, '[data-vf-media-dot]');
    const previous = $(media, '[data-vf-media-previous]');
    const next = $(media, '[data-vf-media-next]');
    if (slides.length < 2) return;

    let active = 0;
    let timer = null;
    const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function show(index) {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, itemIndex) => slide.classList.toggle('is-active', itemIndex === active));
      dots.forEach((dot, itemIndex) => {
        const isActive = itemIndex === active;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-pressed', String(isActive));
      });
    }

    function stopAutoPlay() {
      if (!timer) return;
      window.clearTimeout(timer);
      timer = null;
    }

    function startAutoPlay() {
      stopAutoPlay();
      if (reducedMotion || document.hidden || !root.isConnected) return;
      timer = window.setTimeout(() => {
        show(active + 1);
        startAutoPlay();
      }, 5000);
    }

    function showFromControl(index) {
      show(index);
      startAutoPlay();
    }

    if (previous) previous.addEventListener('click', () => showFromControl(active - 1));
    if (next) next.addEventListener('click', () => showFromControl(active + 1));
    dots.forEach((dot, index) => dot.addEventListener('click', () => showFromControl(index)));
    document.addEventListener('visibilitychange', startAutoPlay);
    startAutoPlay();
  }

  function initFinder(root) {
    if (root.dataset.vfReady === 'true') return;
    root.dataset.vfReady = 'true';

    const makeSelect = $(root, '[data-vf-make]');
    const modelSelect = $(root, '[data-vf-model]');
    const vehicleSelect = $(root, '[data-vf-vehicle]');
    const confirmButton = $(root, '[data-vf-confirm]');
    const clearButton = $(root, '[data-vf-clear]');
    const labels = {
      make: root.dataset.makeLabel || 'Sélectionnez la marque',
      model: root.dataset.modelLabel || 'Sélectionnez le modèle',
      vehicle: root.dataset.vehicleLabel || 'Sélectionnez la motorisation',
      loading: root.dataset.loadingLabel || 'Chargement...'
    };

    const storeId = root.dataset.storeId || 'injecteurgarage';
    const tecDocProfile = root.dataset.tecDocProfile || 'fr';
    const family = root.dataset.family || 'injecteurs';
    const language = root.dataset.language || 'en';
    const startFreshSelection = shouldStartFreshSelection();
    const savedVehicle = startFreshSelection ? null : readSavedVehicle(storeId, tecDocProfile);
    let modelRequestId = 0;
    let vehicleRequestId = 0;
    initMedia(root);

    if (startFreshSelection) {
      clearVehicle();
      removeFreshSelectionFlag();
    }

    function query(extra) {
      const params = new URLSearchParams({
        storeId,
        tecDocProfile,
        lang: language,
        family,
        ...extra
      });
      return params.toString();
    }

    setLoading(makeSelect, labels.loading);
    resetSelect(modelSelect, labels.model);
    resetSelect(vehicleSelect, labels.vehicle);
    renderSelected(root, savedVehicle);

    api(`/makes?${query({})}`)
      .then((makes) => {
        makeSelect.innerHTML = '';
        option(makeSelect, '', labels.make);
        makes.forEach((make) => option(makeSelect, fieldValue(make, ['id', 'Id']), fieldValue(make, ['name', 'Name'])));
        makeSelect.disabled = false;
        setStatus(root, makes.length ? '' : 'Aucune marque compatible n’est disponible pour le moment.');

        const savedMakeId = fieldValue(savedVehicle, ['makeId', 'MakeId']);
        const savedModelId = fieldValue(savedVehicle, ['modelSeriesId', 'ModelSeriesId']);
        const savedVehicleId = vehicleId(savedVehicle);
        if (!savedMakeId || !savedModelId || !savedVehicleId || !hasOption(makeSelect, savedMakeId)) return;

        makeSelect.value = String(savedMakeId);
        const currentModelRequest = ++modelRequestId;
        setLoading(modelSelect, labels.loading);

        return api(`/models?${query({ makeId: savedMakeId })}`)
          .then((models) => {
            if (currentModelRequest !== modelRequestId) return null;
            modelSelect.innerHTML = '';
            option(modelSelect, '', labels.model);
            models.forEach((model) => option(modelSelect, fieldValue(model, ['id', 'Id']), translateVehicleText(fieldValue(model, ['name', 'Name']))));
            modelSelect.disabled = false;
            if (!hasOption(modelSelect, savedModelId)) return null;

            modelSelect.value = String(savedModelId);
            const currentVehicleRequest = ++vehicleRequestId;
            setLoading(vehicleSelect, labels.loading);
            return api(`/vehicles?${query({ makeId: savedMakeId, modelSeriesId: savedModelId })}`)
              .then((vehicles) => ({ vehicles, currentVehicleRequest }));
          })
          .then((result) => {
            if (!result || result.currentVehicleRequest !== vehicleRequestId) return;
            vehicleSelect.innerHTML = '';
            option(vehicleSelect, '', labels.vehicle);
            result.vehicles.forEach((vehicle) => {
              const label = [vehicleName(vehicle), vehicleMeta(vehicle)].filter(Boolean).join(' - ');
              const node = option(vehicleSelect, fieldValue(vehicle, ['id', 'Id']), label);
              node.dataset.vehicle = JSON.stringify(vehicle);
            });
            vehicleSelect.disabled = false;
            if (hasOption(vehicleSelect, savedVehicleId)) {
              vehicleSelect.value = String(savedVehicleId);
              confirmButton.disabled = false;
            }
          });
      })
      .catch((error) => setStatus(root, error.message));

    makeSelect.addEventListener('change', () => {
      const currentModelRequest = ++modelRequestId;
      vehicleRequestId += 1;
      resetSelect(vehicleSelect, labels.vehicle);
      confirmButton.disabled = true;
      const makeId = makeSelect.value;
      if (!makeId) {
        resetSelect(modelSelect, labels.model);
        return;
      }

      setLoading(modelSelect, labels.loading);
      api(`/models?${query({ makeId })}`)
        .then((models) => {
          if (currentModelRequest !== modelRequestId) return;
          modelSelect.innerHTML = '';
          option(modelSelect, '', labels.model);
          models.forEach((model) => option(modelSelect, fieldValue(model, ['id', 'Id']), translateVehicleText(fieldValue(model, ['name', 'Name']))));
          modelSelect.disabled = false;
          setStatus(root, models.length ? '' : 'Aucun modèle compatible n’est disponible pour cette marque.');
        })
        .catch((error) => {
          if (currentModelRequest === modelRequestId) setStatus(root, error.message);
        });
    });

    modelSelect.addEventListener('change', () => {
      const currentVehicleRequest = ++vehicleRequestId;
      confirmButton.disabled = true;
      const makeId = makeSelect.value;
      const modelSeriesId = modelSelect.value;
      if (!makeId || !modelSeriesId) {
        resetSelect(vehicleSelect, labels.vehicle);
        return;
      }

      setLoading(vehicleSelect, labels.loading);
      api(`/vehicles?${query({ makeId, modelSeriesId })}`)
        .then((vehicles) => {
          if (currentVehicleRequest !== vehicleRequestId) return;
          vehicleSelect.innerHTML = '';
          option(vehicleSelect, '', labels.vehicle);
          vehicles.forEach((vehicle) => {
            const label = [vehicleName(vehicle), vehicleMeta(vehicle)].filter(Boolean).join(' - ');
            const node = option(vehicleSelect, fieldValue(vehicle, ['id', 'Id']), label);
            node.dataset.vehicle = JSON.stringify(vehicle);
          });
          vehicleSelect.disabled = false;
          setStatus(root, vehicles.length ? '' : 'Aucune motorisation compatible n’est disponible pour ce modèle.');
        })
        .catch((error) => {
          if (currentVehicleRequest === vehicleRequestId) setStatus(root, error.message);
        });
    });

    vehicleSelect.addEventListener('change', () => {
      confirmButton.disabled = !selectedVehicleFromSelect(vehicleSelect);
    });

    confirmButton.addEventListener('click', () => {
      const vehicle = selectedVehicleFromSelect(vehicleSelect);
      if (!vehicle) return;
      const saved = saveVehicle(root, vehicle);
      renderSelected(root, saved);
      setStatus(root, 'Véhicule enregistré. La compatibilité produit va être vérifiée.');

      window.location.href = buildResultsUrl(root, saved);
    });

    clearButton.addEventListener('click', () => {
      modelRequestId += 1;
      vehicleRequestId += 1;
      clearVehicle();
      renderSelected(root, null);
      makeSelect.value = '';
      resetSelect(modelSelect, labels.model);
      resetSelect(vehicleSelect, labels.vehicle);
      confirmButton.disabled = true;
      setStatus(root, 'Sélection du véhicule effacée.');
    });

    document.addEventListener('vehiclefitment:cleared', () => {
      modelRequestId += 1;
      vehicleRequestId += 1;
      renderSelected(root, null);
      makeSelect.value = '';
      resetSelect(modelSelect, labels.model);
      resetSelect(vehicleSelect, labels.vehicle);
      confirmButton.disabled = true;
    });
  }

  function readSavedVehicle(storeId, tecDocProfile) {
    try {
      const vehicle = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (!vehicle) return null;
      if (vehicle.storeId !== storeId) return null;
      const savedProfile = vehicle.tecDocProfile || vehicle.profile;
      if (savedProfile !== tecDocProfile) return null;
      return vehicle;
    } catch (_) {
      return null;
    }
  }

  function boot() {
    $$(document, '[data-vehicle-finder]').forEach(initFinder);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
